import { combineReducers } from 'redux';

import screen from './reducers/screenReducer';
import gameDetails from './reducers/gameDetailsReducer';
import curriculum from './reducers/curriculumReducer';
import round from './reducers/roundReducer';
import question from './reducers/questionReducer';

const reducers = combineReducers({
  screen,
  gameDetails,
  curriculum,
  round,
  question,
});

export default reducers;
